// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","family":"_1DwOpgSTO6RqXyU0","menuLink":"_3kxUH-pHg9d0yNk_"};